
import Button from '@/components/global/Button'

export default {
  name: 'FilesPlaceholder',
  components: {
    Button
  }
}
